import { render, staticRenderFns } from "./EditCollectItemsActivityCollectStageDialog.vue?vue&type=template&id=1febf91b&scoped=true"
import script from "./EditCollectItemsActivityCollectStageDialog.vue?vue&type=script&lang=js"
export * from "./EditCollectItemsActivityCollectStageDialog.vue?vue&type=script&lang=js"
import style0 from "./EditCollectItemsActivityCollectStageDialog.vue?vue&type=style&index=0&id=1febf91b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1febf91b",
  null
  
)

export default component.exports